import {
  Center,
  Container,
  Flex,
  Heading,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Select,
  Stack,
  Td,
  Text,
  Tr,
  useDisclosure,
  useColorModeValue,
  Button,
  Badge,
} from "@chakra-ui/react";
import React from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import useTableControls from "../../Hooks/useTableControls";
import useFetchApi from "../../Hooks/useFetchApi";
import { BackButton } from "../../components/LayoutUtils";
import TableView from "../../components/TableView";
import Loader from "../../components/Loader";
import CustomPopup from "../../components/CustomPopup";
import moment from "moment";
import { FiEdit3, FiEye, FiDownload } from "react-icons/fi";
import { add_careers } from "../../utils/apis";
import CustomInput from "../../components/CustomInput";
import CustomToolTip from "../../components/CustomTooltip";
import { base_url, base_url_2 } from "../../utils/utils";

/* ── Resume Viewer Modal ── */
const ResumeModal = ({ isOpen, onClose, url }) => {
  const [iframeLoading, setIframeLoading] = React.useState(true);

  React.useEffect(() => {
    if (isOpen) setIframeLoading(true);
  }, [isOpen, url]);

  if (!url) return null;
  const ext = url.split("?")[0].split(".").pop().toLowerCase().trim();
  const isPdf = ext === "pdf";
  const isDoc = ext === "doc" || ext === "docx";

  const handleDownload = async () => {
    try {
      const res = await fetch(url);
      const blob = await res.blob();
      const fileName = url.split("/").pop();
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch {
      window.open(url, "_blank");
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="full">
      <ModalOverlay />
      <ModalContent h="100vh" m={0} borderRadius={0}>
        <ModalHeader borderBottomWidth="1px">
          <Flex align="center" justify="space-between" pr={8}>
            <Flex align="center" gap={3}>
              <Text fontWeight="bold">Resume / CV</Text>
              <Badge colorScheme={isPdf ? "red" : "blue"} fontSize="0.75em">
                {ext.toUpperCase()}
              </Badge>
            </Flex>
            <Flex gap={2}>
              <Button
                size="sm"
                leftIcon={<FiDownload />}
                colorScheme="yellow"
                onClick={handleDownload}
              >
                Download
              </Button>
            </Flex>
          </Flex>
        </ModalHeader>
        <ModalCloseButton zIndex={100} />
        <ModalBody p={0} h="calc(100vh - 72px)" bg="#f5f5f5" position="relative">

          {/* Loading overlay */}
          {iframeLoading && (isPdf || isDoc) && (
            <Flex
              position="absolute"
              top={0} left={0} right={0} bottom={0}
              direction="column"
              align="center"
              justify="center"
              bg="#f5f5f5"
              zIndex={10}
              gap={4}
            >
              <Flex
                w="60px" h="60px"
                borderRadius="full"
                border="5px solid"
                borderColor="yellow.400"
                borderTopColor="transparent"
                animation="spin 0.8s linear infinite"
                style={{ animation: "spin 0.8s linear infinite" }}
              />
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
              <Text fontWeight="medium" color="gray.600" fontSize="sm">
                {isDoc ? "Loading document…" : "Loading PDF…"}
              </Text>
              <Text fontSize="xs" color="gray.400">This may take a few seconds</Text>
            </Flex>
          )}

          {isPdf ? (
            <iframe
              src={`${url}#toolbar=0&navpanes=0&scrollbar=0`}
              style={{ width: "100%", height: "100%", border: "none", opacity: iframeLoading ? 0 : 1 }}
              title="Resume PDF"
              onLoad={() => setIframeLoading(false)}
            />
          ) : isDoc ? (
            <iframe
              src={`https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(url)}`}
              style={{ width: "100%", height: "100%", border: "none", opacity: iframeLoading ? 0 : 1 }}
              title="Resume DOC"
              onLoad={() => setIframeLoading(false)}
            />
          ) : (
            <Flex align="center" justify="center" h="full" direction="column" gap={4}>
              <Text>Cannot preview this file format.</Text>
              <Button leftIcon={<FiDownload />} colorScheme="yellow" onClick={handleDownload}>
                Download File
              </Button>
            </Flex>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

const JobApplicatsDetails = () => {
  const textClr = useColorModeValue("#000", "whiteAlpha.900");
  // job_applicants(job_id,page,limit)
  const {
    rows,
    setRows,
    page,
    setPage,
    id: uid,
    setId,
    search,
    debouncedSearch,
    url,
    setUrl,
    text,
    setText,
    loading,
    setLoading,
  } = useTableControls();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const { state } = useLocation();
  const { id } = state;

  const {
    isOpen: isCOpen,
    onOpen: onCOpen,
    onClose: onCClose,
  } = useDisclosure();
  const {
    isOpen: isCOpen1,
    onOpen: onCOpen1,
    onClose: onCClose1,
  } = useDisclosure();

  const {
    data,
    isLoading,
    refetch: handleFetchData,
  } = useFetchApi({
    path: "careers.php",
    formDataArr: {
      action: "job_applicants",
      limit: rows,
      page: page,
      job_id: id,
      value: debouncedSearch,
    },
  });

  // update_applicant_status( id, status)

  const update_status = async (id, text) => {
    try {
      const body = new FormData();
      body.append("action", "update_applicant_status");
      body.append("id", id);
      body.append("status", text);
      add_careers(body).then((v) => {
        if (v.success) {
          handleFetchData();
        }
      });
    } catch (error) {
      console.log("error ===", error);
    }
  };

  const update_comment = async (id, text) => {
    try {
      setLoading(true);
      const body = new FormData();
      body.append("action", "comment");
      body.append("id", id);
      body.append("comment", text);
      add_careers(body).then((v) => {
        if (v.success) {
          handleFetchData();
          onCClose();
        }
      });
    } catch (error) {
      console.log("error ===", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container h={"full"} w={"full"} maxW={"full"}>
      <Flex justify={"space-between"}>
        <Heading fontSize={"xl"}>Applicant List</Heading>
        <BackButton />
      </Flex>
      <Flex gap={2} align={"center"}>
        <Text fontSize={"xl"} color={textClr} fontWeight={"normal"}>
          Total Applicant : {data?.totalCount}
        </Text>
      </Flex>

      {isLoading && data?.data?.length === 0 ? (
        <Loader />
      ) : data?.data?.length === 0 ? (
        <Center bg={"#fff"} borderRadius={10}>
          <Image src="no-data.jpg" h={"md"} objectFit={"contain"} />
        </Center>
      ) : (
        <TableView
          pagination={true}
          initialValue={page * rows - rows + 1}
          rows={rows}
          page={page}
          onNext={() => {
            if (
              page <
              Math.ceil((search ? data?.searchCount : data?.totalCount) / rows)
            ) {
              setPage(page + 1);
            }
          }}
          onPrevious={() => {
            if (page > 1) {
              setPage(page - 1);
            }
          }}
          onChange={(e) => {
            setPage(1);
            setRows(e.target.value);
          }}
          total_value={search ? data?.searchCount : data?.totalCount}
          headData={[
            "S.No.",
            "Full Name",
            "Email",
            "Mobile",
            "Linkdin",
            "Status",
            "Resume / CV",
            "Comment",
          ]}
          body={data?.data?.map((v, i) => (
            <Tr key={i}>
              <Td textAlign={"center"}>{i + 1 + rows * (page - 1)}</Td>
              <Td textAlign={"center"}>{v?.full_name}</Td>
              <Td textAlign={"center"}>{v?.email}</Td>
              <Td textAlign={"center"}>{v?.phone_number}</Td>
              <Td textAlign={"center"}>
                <p
                  style={{
                    textDecoration: "underline",
                    fontWeight: "bold",
                    color: "blue",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                      const url = v?.linkedin_profile;
                      if (!url || url.trim() === "" || url === "undefined" || url === "null") {
                        toast.info("LinkedIn link not available");
                        return;
                      }
                      window.open(url.startsWith("http") ? url : `https://${url}`, "_blank");
                    }}
                >
                  link
                </p>
              </Td>
              <Td textAlign={"center"} w={"36"}>
                <Select
                  w={"32"}
                  size={"sm"}
                  borderRadius={"md"}
                  value={v.status}
                  onChange={(e) => update_status(v.id, e.target.value)}
                >
                  <option value="1">Knew</option>
                  <option value="2">In Progress</option>
                  <option value="3">On Hold</option>
                  <option value="4">Recruit</option>
                  <option value="5">Rejected</option>
                </Select>
              </Td>

              <Td textAlign={"center"}>
                <Flex gap={3} justify={"center"}>
                  <FiEye
                    size={20}
                    cursor={"pointer"}
                    onClick={() => {
                      const resume = v?.resume;
                      if (!resume || resume.trim() === "" || resume === "undefined" || resume === "null") {
                        toast.info("Resume / CV not available");
                        return;
                      }
                      const finalUrl = resume.startsWith("http") ? resume : base_url_2 + resume;
                      setUrl(finalUrl);
                      onOpen();
                    }}
                  />
                </Flex>
              </Td>
              <Td textAlign={"center"}>
                <Flex gap={2} justifyContent={"center"}>
                  <CustomToolTip
                    button={
                      <FiEye
                        size={20}
                        cursor={"pointer"}
                        onClick={() => {
                          setId(v.id);
                          setText(v.comment);
                          onCOpen1();
                        }}
                      />
                    }
                    mess={"View Comment"}
                  />
                  <CustomToolTip
                    button={
                      <FiEdit3
                        size={20}
                        cursor={"pointer"}
                        onClick={() => {
                          setId(v.id);
                          setText(v.comment);
                          onCOpen();
                        }}
                      />
                    }
                    mess={"Edit Comment"}
                  />
                </Flex>
              </Td>
            </Tr>
          ))}
        />
      )}

      <ResumeModal isOpen={isOpen} onClose={onClose} url={url} />

      <CustomPopup
        isOpen={isCOpen1}
        onClose={onCClose1}
        title={"Comment"}
        single_button
        mess={
          <Stack>
            {text.length == 0 ? (
              <Text>No Comment, Please add comment</Text>
            ) : (
              <Text>{text}</Text>
            )}
          </Stack>
        }
      />

      <CustomPopup
        isOpen={isCOpen}
        onClose={onCClose}
        title={"Comment"}
        b_name={"Update"}
        onClick={() => update_comment(uid, text)}
        b_color={"#FFBF00"}
        loading={loading}
        mess={
          <Stack>
            {text.length == 0 && <Text>No Comment, Please add comment</Text>}
            <CustomInput
              area1
              onlyone
              value1={text}
              onChange1={(e) => setText(e.target.value)}
              placeholder1={"Enter Comment..."}
            />
          </Stack>
        }
      />
    </Container>
  );
};

export default JobApplicatsDetails;
